const resultSummaryReportTypes = {
  resultSummary: 1,
  achievementSummary: 2,
};

export default resultSummaryReportTypes;
